import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { FileService } from "../../services/file-service";
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from "../../_base/crud";
import { map } from "rxjs/operators";
import { environment } from "../../../../environments/environment";
import {HTTPService} from "../../../../../src/app/service/http.service";
import {HTTPRequestBuilder} from "../../../../../src/app/model/http.request.model";
import {EnvironmentService} from "../../../../../src/app/service/environment.service";
import {HTTPMethod} from "../../../../../src/app/model/http-method.enum";
import { PagedQuery } from "../../../persistence/dto/paged-query.model";
import { MimeType } from "../../../model/mime-type.enum";
import { TypeSystem } from "../../../support/type-system.support";
import { BuyIntentionForUpdate } from "../../../persistence/dto/buy-intention-for-update";
import { OrderEventBasket } from "../_models/order-events-basket.model";
import { catchError } from "rxjs/operators";
import { OrderEventBasketDto, OrderEventBasketNewMaterial } from "../../models/orderEventBasketDto.model";

@Injectable({
  providedIn: "root"
})
export class OrderEventsReturnsService {

  private API_OrderEventBasket_URL = environment.API_URL + "api/OrderEvent/orderEventBasket";
  constructor(private httpService: HTTPService,private http: HttpClient, private fileService: FileService, private httpUtils: HttpUtilsService, private environmentService: EnvironmentService) {}

  hostPath(): string {
    return this.environmentService.backendHost.href;
  }
  public basePath(): string {
      return "api/orderevent";
  }


  public findReturnedBasket(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
    return this.httpService.send<QueryParamsModel, QueryResultsModel>(
        new HTTPRequestBuilder<QueryParamsModel>()
            .method(HTTPMethod.POST)
            .host(this.hostPath())
            .controllerPath(this.basePath())
            .relativePath(`/returnedBaskets`)
            .payload(queryParams)
            .build()
    )
  }

    public reopenOrderEventBasket(orderEventBasketId: number): Observable<any> {
        return this.httpService.send<any, any>(
            new HTTPRequestBuilder<any>()
                .method(HTTPMethod.POST)
                .host(this.hostPath())
                .controllerPath(this.basePath())
                .relativePath(`/orderEventBasket/reopen/${orderEventBasketId}`)
                .build()
        );
    }


  public downloadBasketReceptionSheet(orderEventBasketId: number): Observable<Blob> {
    return this.httpService.send<any, Blob>(
        new HTTPRequestBuilder<any>()
            .method(HTTPMethod.POST)
            .host(this.hostPath())
            .controllerPath(this.basePath())
            .relativePath(`/download-basket-reception-sheet/${orderEventBasketId}`)
            .responseType('blob')
            .build()
    ).pipe(
        map((res: Blob) => {
            return new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        })
    );
}

public downloadBasketBalance(orderEventBasketId: number): Observable<Blob> {
    return this.httpService.send<any, Blob>(
        new HTTPRequestBuilder<any>()
            .method(HTTPMethod.POST)
            .host(this.hostPath())
            .controllerPath(this.basePath())
            .relativePath(`/download-basket-balance/${orderEventBasketId}`)
            .responseType('blob')
            .build()
    ).pipe(
        map((res: Blob) => {
            return new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        })
    );
}

public downloadBasketResume(orderEventBasketId: number): Observable<Blob> {
    return this.httpService.send<any, Blob>(
        new HTTPRequestBuilder<any>()
            .method(HTTPMethod.POST)
            .host(this.hostPath())
            .controllerPath(this.basePath())
            .relativePath(`/download-basket-resume/${orderEventBasketId}`)
            .responseType('blob')
            .build()
    ).pipe(
        map((res: Blob) => {
            return new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        })
    );
}

  public getReturnedBasketById(orderEventBasketId: number): Observable<OrderEventBasketDto> {
    return this.httpService.send<any, OrderEventBasketDto>(
        new HTTPRequestBuilder<any>()
            .method(HTTPMethod.POST)
            .host(this.hostPath())
            .controllerPath(this.basePath())
            .relativePath(`/orderEventBasket/${orderEventBasketId}`)
            .build()
    )
  }

  public searchMaterials(term: string): Observable<OrderEventBasketNewMaterial[]> {
    return this.http.get<OrderEventBasketNewMaterial[]>(`${this.API_OrderEventBasket_URL}/materials-search?term=${term}`);
  }

  updateOrderEventBasket(orderEventBasket: OrderEventBasketDto): Observable<any> {
    return this.http.put<OrderEventBasketDto>(this.API_OrderEventBasket_URL, orderEventBasket, {
      headers: this.httpUtils.getHTTPHeaders()
    });
  }

  getReturnedBasketById1(orderEventBasketId: number): Observable<OrderEventBasket> {
    return this.http.get<OrderEventBasket>(this.API_OrderEventBasket_URL +  `/${orderEventBasketId}`).pipe(catchError((err) => of(null)));
  }
}
